//@ts-ignore
import Axios from "axios";

// Initialize the instance before making any API calls
const instance = Axios.create({
  baseURL: "https://tenantcontrolservice.careinfosolutions.com/api/",
  headers: {
    "Content-Type": "application/json",
  },
});
instance.interceptors.request.use(
  (config) => {
    const schemaName = localStorage.getItem("schema_name");
    if (schemaName) {
      config.headers["X-Tenant-Schema"] = schemaName;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

export default instance;
// Get data from API
export const getApiData = async (url, param = null) => {
  let response;
  try {
    response = await instance({
      method: "GET",
      url: `${url}`,
      params: param,
      transformResponse: [
        function (responseData) {
          // Do whatever you want to transform the data
          return JSON.parse(responseData);
        },
      ],
    });
  } catch (e) {
    return e.response;
  }
  return response;
};
export const postApiData = async (data) => {
  const { url, formData, setError } = data;
  let response;
  try {
    response = await instance({
      method: "POST",
      url: `${url}`,
      data: formData,
      transformResponse: [
        function (responseData) {
          // Do whatever you want to transform the data
          return JSON.parse(responseData);
        },
      ],
    });
  } catch (e) {
    for (const key in e.response?.data) {
      if (e.response?.data.hasOwnProperty(key)) {
        setError(key, { type: "custom", message: e.response?.data[key] });
      }
    }
    return e.response;
  }
  return response;
};
export const postApiFormData = async (data: any) => {
  const { url, formData, setError } = data;
  let response;
  try {
    response = await instance({
      method: "POST",
      url: `${url}`,
      data: formData,
      headers: {
        "Content-Type": `multipart/form-data`,
      },
      transformResponse: [
        function (responseData: any) {
          //Do whatever you want to transform the data
          return JSON.parse(responseData);
        },
      ],
    });
  } catch (e: any) {
    for (const key in e.response?.data) {
      if (e.response?.data.hasOwnProperty(key) && setError) {
        setError(key, { type: "custom", message: e.response?.data[key] });
      }
    }
    return e.response;
  }
  return response;
};
